import { render, staticRenderFns } from "./MppAppTabbar.vue?vue&type=template&id=c7615052&scoped=true"
import script from "./MppAppTabbar.vue?vue&type=script&lang=js"
export * from "./MppAppTabbar.vue?vue&type=script&lang=js"
import style0 from "./MppAppTabbar.vue?vue&type=style&index=0&id=c7615052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7615052",
  null
  
)

export default component.exports